import {Form, loader} from './Form';
import {Confirmation} from './Confirmation';

export default {
    Form,
    loader,
    Confirmation,
};
